export default "__VITE_ASSET__CKQnPVTB__"